import React, { FC } from "react";
import { Form, Input, DatePicker, Row, Col } from "antd";

interface AdmissionDetailsProps {
  isEditable: boolean;
  caseClaimSubmissionId: number | null;
  totalClaimedAmount: any;
  onAmountChange?: any;
}

const AdmissionDetails: FC<AdmissionDetailsProps> = ({
  isEditable,
  caseClaimSubmissionId,
  totalClaimedAmount,
  onAmountChange
}) => {
  return (
    <>
      <h3>Admission Details</h3>
      <Row gutter={[16, 16]}>
        {/* <Col span={8}>
          <Form.Item
            name="claimNo"
            label="Claim No."
            rules={[{ required: true, message: "Required" }]}
          >
            <Input disabled={!isEditable} />
          </Form.Item>
        </Col> */}
        <Col span={8}>
          <Form.Item
            name="dateOfAdmission"
            label="Admission/OPD Date"
            rules={[{ required: true, message: "Required" }]}
          >
            <DatePicker
              showTime
              format="DD-MM-YYYY HH:mm:ss"
              disabled={true}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="claimedAmount"
            label="Net Claim Amount"
            rules={[
              { required: true, message: "Required" },
              {
                validator: async (_, value) => {
                  if (parseFloat(totalClaimedAmount) > 0) {
                    if (
                      value &&
                      parseFloat(value) > parseFloat(totalClaimedAmount)
                    ) {
                      return Promise.reject(
                        new Error(
                          `Claimed Amount must be lesser than or equal to ${totalClaimedAmount}`
                        )
                      );
                    }
                  }
                },
              },
              {
                pattern: /^\d+$/,
                message: "Only Numeric values are allowed!",
              },
            ]}
          >
            <Input disabled={!isEditable} onChange={() => onAmountChange?.()}/>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default AdmissionDetails;
